module.exports = __webpack_public_path__ + "static/media/CPD-plan.75ed900b.svg";